import React, { useState, useEffect, useContext } from 'react';
// import Breadcrumb from '../nav/Breadcrumb'
import { Navigate } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import Select from 'react-select';
import exportConfig from '../config';
import useGainsQCApi from '../services/useGainsQCApi';
import Skeleton from 'react-loading-skeleton';
import { Tooltip } from 'react-tooltip';
import CaptureModal from '../components/modals/CaptureModal';
import { endpointContext } from '../contexts/endpointContext';
import CapturesTable from '../components/tables/CapturesTable';
import { smelterFieldsCapturesPage } from '../components/tables/tableFields';

export default function Captures(props) {
	/**
	 * Provides user ability to fetch captures and view without QCing
	 */

	let formInitialValues = {
		// MAIN CRITERIA
		queueIds: [],
		captureIds: [],
		siteIds: [],
		siteComm: 3,
		siteProdState: [-2, -1, 0, 1, 2, 5],

		// additional site info
		siteType: 1,

		// additional capture info
		sensors: exportConfig.sensors,
		models: [],
		origins: [],
		allowPixels: false,
		pixelsMin: 0,
		pixelsMax: 10000,
		allowHotspots: false,
		hotspotsMin: 0,
		hotspotsMax: 20,
		allowCloudFrac: false,

		cloudFracMin: 0,
		cloudFracMax: 1,
		allowInvalidDataFrac: false,
		invalidDataFracMin: 0,
		invalidDataFracMax: 1,
		allowCaptureDates: false,
		captureStartDate: new Date(new Date().setDate(new Date().getDate() - 1))
			.toISOString()
			.split('T')[0],
		captureEndDate: new Date().toISOString().split('T')[0],
		// captureStartDate: '',
		// captureEndDate: '',

		// additional qc info
		allowQCState: false,
		qcStates: [0],
		qcInitialState: ['null', -1, 0, 1],
		qcFinalState: ['null', -1, 0, 1],
		qcStartDate: '',
		qcEndDate: '',
		qcStatesAgree: true,
		qcStatesDisagree: true
	};

	const endpointContextCaptures = useContext(endpointContext);

	const [formValue, setFormValue] = useState(formInitialValues);
	const [currentImage, setCurrentImage] = useState(null);

	let qcUsers = [
		{
			approvedBy: 'Qurratul',
			emailVerified: 'true',
			organisation: 'Earth-i',
			givenName: 'Joshua',
			userRole: 'admin',
			familyName: 'Large',
			email: 'Josh.large@earthi.co.uk',
			username: '020c9f7a-52e1-41c2-8090-938bc16f0ad2',
			enabled: true,
			userCreateDate: '2025-02-04T16:12:31.178000+02:00',
			userLastModifiedDate: '2025-02-25T18:03:18.940000+02:00',
			userStatus: 'CONFIRMED'
		},
		{
			emailVerified: 'true',
			userRole: 'superUser',
			organisation: 'Earth-i',
			givenName: 'Antony',
			familyName: 'Blackwell',
			email: 'antony.blackwell@earthi.co.uk',
			username: '06774575-73eb-4d2d-bd28-748c8f2ddf99',
			enabled: true,
			userCreateDate: '2023-03-14T15:28:25.216000+02:00',
			userLastModifiedDate: '2024-07-18T14:50:11.110000+03:00',
			userStatus: 'CONFIRMED'
		},
		{
			approvedBy: 'gordana@nikolic.si',
			emailVerified: 'true',
			userRole: 'admin',
			organisation: 'Earthi',
			givenName: 'Syed',
			familyName: 'Akhtar',
			email: 'syed.akhtar@earthi.co.uk',
			username: '08c272e7-e071-4563-96f1-a87891332a9f',
			enabled: true,
			userCreateDate: '2024-03-12T16:56:01.692000+02:00',
			userLastModifiedDate: '2024-03-26T11:29:52.323000+02:00',
			userStatus: 'CONFIRMED'
		},
		{
			emailVerified: 'true',
			userRole: 'admin',
			organisation: 'Earth-i',
			givenName: 'Guy',
			familyName: 'Cook',
			email: 'guy.cook@earthi.co.uk',
			username: '1034f789-234e-4297-b4be-95f042e44b9a',
			enabled: true,
			userCreateDate: '2023-01-19T16:56:29.554000+02:00',
			userLastModifiedDate: '2023-07-26T14:15:04.736000+03:00',
			userStatus: 'CONFIRMED'
		},
		{
			approvedBy: 'lucy.colley@earthi.co.uk',
			emailVerified: 'true',
			userRole: 'admin',
			organisation: 'EarthI',
			givenName: 'George',
			familyName: 'Begkas',
			email: 'george.begkas@earthi.co.uk',
			username: '1f573631-5d96-49cf-9f51-6f420114b36f',
			enabled: true,
			userCreateDate: '2023-06-07T10:46:22.394000+03:00',
			userLastModifiedDate: '2023-08-21T11:20:20.578000+03:00',
			userStatus: 'CONFIRMED'
		},
		{
			emailVerified: 'true',
			userRole: 'superUser',
			organisation: 'Earth-i',
			givenName: 'Chetan',
			familyName: 'Pradhan',
			email: 'chetan.pradhan@earthi.co.uk',
			username: '4d96df9c-5bbe-4cde-b951-6d4b02b35526',
			enabled: true,
			userCreateDate: '2023-01-25T16:14:55.995000+02:00',
			userLastModifiedDate: '2023-07-10T16:47:46.506000+03:00',
			userStatus: 'CONFIRMED'
		},
		{
			approvedBy: 'gordana.nikolic@earthi.co.uk',
			emailVerified: 'true',
			userRole: 'admin',
			organisation: 'Earth-i',
			givenName: 'Akis',
			familyName: 'Karagiannis',
			email: 'xenofon.karagiannis@earthi.co.uk',
			username: '50e633e3-a753-4fd3-bbf8-a4ada818785d',
			enabled: true,
			userCreateDate: '2024-10-25T12:45:02.013000+03:00',
			userLastModifiedDate: '2025-02-03T20:11:37.262000+02:00',
			userStatus: 'RESET_REQUIRED'
		},
		{
			approvedBy: 'lucy.colley@earthi.co.uk',
			emailVerified: 'true',
			userRole: 'admin',
			organisation: 'Earth-i',
			givenName: 'Madiha',
			familyName: 'Abbas',
			email: 'madiha.abbas@earthi.co.uk',
			username: '5ad1ffc3-0655-4d9b-8ca6-127f8718a663',
			enabled: true,
			userCreateDate: '2023-04-24T21:36:45.526000+03:00',
			userLastModifiedDate: '2025-04-08T13:27:11.376000+03:00',
			userStatus: 'CONFIRMED'
		},
		{
			emailVerified: 'true',
			userRole: 'admin',
			organisation: 'Earth-i',
			givenName: 'Lucy',
			familyName: 'Colley',
			email: 'lucy.colley@earthi.co.uk',
			username: '75110fc4-6373-4e5f-a989-7e31c7cf1b52',
			enabled: true,
			userCreateDate: '2023-02-27T13:44:00.863000+02:00',
			userLastModifiedDate: '2023-08-31T11:00:44.283000+03:00',
			userStatus: 'CONFIRMED'
		},
		{
			approvedBy: 'gordana.nikolic@earthi.co.uk',
			emailVerified: 'true',
			userRole: 'admin',
			organisation: 'Earth-i',
			givenName: 'Gordana',
			familyName: 'Nikolic',
			email: 'gordana@nikolic.si',
			username: '7ab62268-b184-49f0-94b8-03ad0e4243e1',
			enabled: true,
			userCreateDate: '2024-08-21T13:13:32.423000+03:00',
			userLastModifiedDate: '2024-10-29T14:14:10.240000+02:00',
			userStatus: 'CONFIRMED'
		},
		{
			approvedBy: 'lucy.colley@earthi.co.uk',
			emailVerified: 'true',
			userRole: 'admin',
			organisation: 'earthi',
			givenName: 'Qurratul',
			familyName: 'Khan',
			email: 'qurratul.khan@earthi.co.uk',
			username: '813bc65d-f953-40c4-a2dd-466bdc959a82',
			enabled: true,
			userCreateDate: '2023-01-16T13:13:33.786000+02:00',
			userLastModifiedDate: '2025-05-27T15:24:54.386000+03:00',
			userStatus: 'CONFIRMED'
		},
		{
			emailVerified: 'true',
			userRole: 'admin',
			organisation: 'Earth-i',
			givenName: 'Peter',
			familyName: 'Hausknecht',
			email: 'peter.hausknecht@earthi.co.uk',
			username: '9de01cc9-a8f8-4d37-a154-0ddcb7ec5627',
			enabled: true,
			userCreateDate: '2023-06-13T13:07:20.756000+03:00',
			userLastModifiedDate: '2025-02-25T11:32:51.309000+02:00',
			userStatus: 'CONFIRMED'
		},
		{
			approvedBy: 'lucy.colley@earthi.co.uk',
			emailVerified: 'true',
			userRole: 'editor',
			organisation: 'Earth-i',
			givenName: 'Lucy test',
			familyName: 'last name test',
			email: 'lucycatherine92@gmail.com',
			username: 'b91c5756-658d-4faa-b791-0f7f48777fd9',
			enabled: true,
			userCreateDate: '2023-04-21T15:38:40.109000+03:00',
			userLastModifiedDate: '2024-03-13T16:11:36.792000+02:00',
			userStatus: 'CONFIRMED'
		},
		{
			emailVerified: 'true',
			userRole: 'denied',
			organisation: 'Earth-i',
			givenName: 'Lucy test',
			familyName: 'last name test',
			email: 'argentinabatrojo@gmail.com',
			username: 'cbd063e8-4c81-45f3-b514-09e0bc914e65',
			enabled: true,
			userCreateDate: '2023-05-30T15:01:28.275000+03:00',
			userLastModifiedDate: '2023-05-30T15:02:47.645000+03:00',
			userStatus: 'CONFIRMED'
		},
		{
			emailVerified: 'true',
			userRole: 'admin',
			organisation: 'independant',
			givenName: 'Varsha',
			familyName: 'Pradhan',
			email: 'vpradhan@hotmail.co.uk',
			username: 'd5692976-f522-4ba5-ac00-ff737f264b3d',
			enabled: true,
			userCreateDate: '2023-04-03T15:38:30.054000+03:00',
			userLastModifiedDate: '2025-02-10T16:03:00.066000+02:00',
			userStatus: 'CONFIRMED'
		},
		{
			approvedBy: 'lucy.colley@earthi.co.uk',
			emailVerified: 'true',
			organisation: 'Earth-i',
			givenName: 'Lucy',
			userRole: 'admin',
			familyName: 'Colley',
			email: 'fipsehurzu@gufum.com',
			username: 'eb9663ae-21f7-4929-9fa4-5539d58e97e9',
			enabled: true,
			userCreateDate: '2024-05-14T13:18:55.226000+03:00',
			userLastModifiedDate: '2024-05-14T13:24:34.136000+03:00',
			userStatus: 'CONFIRMED'
		},
		{
			emailVerified: 'true',
			userRole: 'superUser',
			organisation: 'SCA',
			givenName: 'Charles',
			familyName: 'Davis',
			email: 'cdrdavis@hotmail.com',
			username: 'fea6006c-1c63-47e1-bd52-89561c29e308',
			enabled: true,
			userCreateDate: '2023-01-17T23:13:28.678000+02:00',
			userLastModifiedDate: '2023-05-19T18:02:38.125000+03:00',
			userStatus: 'CONFIRMED'
		}
	];

	const MAX_LENGTH = 5;

	const [formValid, setFormValid] = useState(true);
	const [formValidReason, setFormValidReason] = useState('');
	const [commsForSiteType, setCommsForSiteType] = useState(
		endpointContextCaptures?.dbData?.allCommodities.filter(
			(comm) => comm.siteTypeStr === 'smelter'
		)
	);
	const [selectedSiteOptions, setSelectedSiteOptions] = useState([]);
	const [selectedUserOptions, setSelectedUserOptions] = useState([]);
	const [formUpdated, setFormUpdated] = useState(false);
	const [selectedCaptureIDOptions, setSelectedCaptureIDOptions] = useState([]);
	const [inputValueCaptureIds, setInputValueCaptureIds] = useState('');
	const [inputValueQueueIds, setInputValueQueueIds] = useState('');
	const [fetchCapturesUrl, setFetchCapturesUrl] = useState('');

	const [criteriaFormIsOpen, setCriteriaFormIsOpen] = useState(true);

	const toggleAccordion = () => {
		setCriteriaFormIsOpen((prev) => !prev);
	};

	const {
		data: sites,
		loading: loadingSites,
		error: errorSites,
		makeRequest: makeRequestSites
	} = useGainsQCApi();

	const fetchCaptures = useGainsQCApi();

	const [siteOptions, setSiteOptions] = useState([]);
	const [userOptions, setUserOptions] = useState([]);

	const calcDatesDiff = (startDate, endDate) => {
		const start = new Date(startDate);
		const end = new Date(endDate);

		if (start > end) [start, end] = [end, start]; // ensure correct order

		const diff = {
			years: 0,
			months: 0,
			weeks: 0,
			days: 0
		};

		// Calculate years and months
		let current = new Date(start);
		while (
			new Date(
				current.getFullYear() + 1,
				current.getMonth(),
				current.getDate()
			) <= end
		) {
			diff.years++;
			current.setFullYear(current.getFullYear() + 1);
		}

		while (
			new Date(
				current.getFullYear(),
				current.getMonth() + 1,
				current.getDate()
			) <= end
		) {
			diff.months++;
			current.setMonth(current.getMonth() + 1);
		}

		// Remaining days
		const msPerDay = 1000 * 60 * 60 * 24;
		const remainingDays = Math.floor((end - current) / msPerDay);
		diff.weeks = Math.floor(remainingDays / 7);
		diff.days = remainingDays % 7;

		// Format output
		const parts = [];
		if (diff.years)
			parts.push(`${diff.years} year${diff.years > 1 ? 's' : ''}`);
		if (diff.months)
			parts.push(`${diff.months} month${diff.months > 1 ? 's' : ''}`);
		if (diff.weeks)
			parts.push(`${diff.weeks} week${diff.weeks > 1 ? 's' : ''}`);
		if (diff.days) parts.push(`${diff.days} day${diff.days > 1 ? 's' : ''}`);

		return parts.length ? parts.join(', ') : '0 days';
	};

	const validateForm = () => {
		let isFormValid = true;
		setFormValidReason('');

		console.log('validating form');

		if (!formValue.siteComm) {
			isFormValid = false;
			setFormValidReason('You must select a commodity');
		}

		if (
			formValue.siteComm === 3 &&
			formValue.captureIds.length === 0 &&
			formValue.siteIds.length === 0
		) {
			if (!formValue.siteProdState?.length || !formValue.siteComm) {
				//	console.log('here 3');
				isFormValid = false;
				setFormValidReason(
					'You must select a commodity and at least one production state, or provide site IDs or capture IDs'
				);
			}
		}

		if (formValue.qcStates.includes(1)) {
			if (formValue.qcEndDate < formValue.qcStartDate) {
				isFormValid = false;
				setFormValidReason('QC Date end date is before QC Date start date');
			}

			// also determine that QC dates are after captures date
			if (
				formValue.qcEndDate < formValue.captureEndDate ||
				formValue.qcEndDate < formValue.captureStartDate
			) {
				isFormValid = false;
				setFormValidReason('QC Dates are before capture dates');
			}
		}

		if (
			new Date(formValue.captureStartDate) > new Date(formValue.captureEndDate)
		) {
			setFormValid(false);
			setFormValidReason('Captures end date are before start date');
		}

		setFormValid(isFormValid);
		return isFormValid;
	};

	useEffect(() => {
		// IMPORTANT - check always passing a comm

		setFormUpdated(true);
		setCurrentImage(null);
		let isFormValid = validateForm();

		if (isFormValid) {
			let apiString = '';

			if (formValue.captureIds.length > 0) {
				//console.log('Capture IDS');
				const capsId = JSON.stringify({
					[formValue.siteComm]: formValue.captureIds.map((c) => Number(c.value))
				});
				apiString = apiString + `captureIds=${capsId}`;
			} else if (formValue.siteIds.length > 0) {
				//console.log('Site IDS');
				apiString = apiString + `siteIds=${formValue.siteIds.join(',')}`;
			} else if (formValue.siteComm && formValue.siteProdState.length > 0) {
				//console.log('Comm + Prod State');
				if (formValue.siteComm) {
					console.log('Form value site comm', formValue.siteComm);
					apiString = apiString + `commodityIds=${formValue.siteComm}`;
				}

				if (formValue.siteProdState.length > 0) {
					console.log('Form value prod states', formValue.siteProdState);
					apiString =
						apiString + '&' + `prodStates=${formValue.siteProdState.join(',')}`;
				}
			} else {
				//console.log('here 4');
			}

			if (formValue.allowCaptureDates) {
				if (formValue.captureStartDate) {
					apiString =
						apiString + '&' + `startDate=${formValue.captureStartDate}`;
				} else {
					apiString = apiString + '&' + `startDate=2016-01-01`;
				}

				if (formValue.captureEndDate) {
					apiString = apiString + '&' + `endDate=${formValue.captureEndDate}`;
				} else {
					apiString =
						apiString +
						'&' +
						`endDate=${new Date().toISOString().split('T')[0]}`;
				}
			}

			if (formValue.sensors.length > 0 && formValue.sensors.length !== 3) {
				apiString = apiString + '&' + `sensors=${formValue.sensors}`;
			}

			if (formValue.origins.length > 0) {
				apiString = apiString + '&' + `origins=${formValue.origins}`;
			}

			if (formValue.models.length > 0) {
				apiString = apiString + '&' + `models=${formValue.models}`;
			}

			if (formValue.allowHotspots) {
				apiString =
					apiString +
					'&' +
					`hotspots=${formValue.hotspotsMin},${formValue.hotspotsMax}`;
			}

			if (formValue.allowCloudFrac) {
				apiString =
					apiString +
					'&' +
					`cloudFrac=${formValue.cloudFracMin},${formValue.cloudFracMax}`;
			}

			if (formValue.allowInvalidDataFrac) {
				apiString =
					apiString +
					'&' +
					`invalidDataFrac=${formValue.invalidDataFracMin},${formValue.invalidDataFracMax}`;
			}

			if (formValue.allowMaxPixels) {
				apiString =
					apiString +
					'&' +
					`totalPixels=${formValue.pixelsMin},${formValue.pixelsMax}`;
			}

			if (formValue.qcStates.length > 0 && formValue.qcStates.length !== 2) {
				apiString = apiString + '&' + `qcState=${formValue.qcStates.join(',')}`;
			}

			if (
				formValue.qcInitialState.length > 0 &&
				formValue.qcInitialState.length !== 4
			) {
				apiString =
					apiString +
					'&' +
					`initialState=${formValue.qcInitialState.join(',')}`;
			}

			if (
				formValue.qcFinalState.length > 0 &&
				formValue.qcFinalState.length !== 4
			) {
				apiString =
					apiString + '&' + `state=${formValue.qcFinalState.join(',')}`;
			}

			if (formValue.qcStartDate) {
				apiString = apiString + '&' + `qcDateStart=${formValue.qcStartDate}`;
			}

			if (formValue.qcEndDate) {
				apiString = apiString + '&' + `qcDateEnd=${formValue.qcEndDate}`;
			}

			if (selectedUserOptions.length > 0) {
				let selectedUsers = selectedUserOptions.map((u) => u.label).join(',');
				apiString = apiString + '&' + `qcUser=${selectedUsers}`;
			}

			console.log("apiString",apiString);

			setFetchCapturesUrl(
				`/${
					exportConfig.siteTypesIds.filter(
						(siteType) => siteType.id === formValue['siteType']
					)[0].name
				}/captures?${apiString}`
			);
		} else {
			console.log('FORM NOT VALID');
		}
	}, [formValue]);

	useEffect(() => {
		if (formValue.qcStates.includes(1)) {
			setFormValue({
				...formValue,
				qcStartDate: formValue.captureStartDate,
				qcEndDate: formValue.captureEndDate
			});
		} else {
			setFormValue({
				...formValue,
				qcStartDate: '',
				qcEndDate: ''
			});
		}

		if (formValue.qcStates.length === 0) {
			setFormValue({
				...formValue,
				qcStates: [0, 1]
			});
		}
	}, [formValue.qcStates]);

	useEffect(() => {
		/**
		 * when site type is changed, get commodities for site type
		 * and fetch sites for site type,
		 * reset selectedSites
		 */

		setSelectedSiteOptions([]);

		setFormValue({
			...formValue,
			siteComm: 3,
			siteProdState:
				formValue['siteType'] === 1 ? formInitialValues.siteProdState : [],
			qcFinalState: [],
			qcInitialState: [],
			hotspotsMin: 0,
			hotspotsMax: 20,
			cloudFracMin: 0,
			cloudFracMax: 1
		});

		// change this when finished dev
		makeRequestSites(
			`/${
				exportConfig.siteTypesIds.filter(
					(siteType) => siteType.id === formValue['siteType']
				)[0].name
				//}/sites?hasCaptures=true`,
			}/sites`,
			'GET',
			null,
			'sites',
			0
		);
	}, [formValue['siteType']]);

	useEffect(() => {
		/**
		 * when commodity or prod_state is selected,
		 * filter sites to only relevant commodities and production states
		 */

		let sitesFiltered;
		if (sites && sites.data) {
			// console.log('All sites from smelters EP', sites.data);
			// console.log('Site type id', formValue.siteType);
			// console.log('Site comm', formValue.siteComm);
			// console.log('Site prod states', formValue.siteProdState);
			if (formValue.siteType === 1) {
				sitesFiltered = sites.data.filter(
					(site) =>
						site.commodity_id === formValue.siteComm &&
						formValue.siteProdState.includes(parseInt(site.prod_state))
				);
			} else {
				sitesFiltered = sites.data.filter(
					(site) => site.commodity_id === formValue.siteComm
				);
			}

			//console.log('Filtered sites', sitesFiltered);

			setSiteOptions(
				sitesFiltered.map(({ id, name, commodity_id }) => ({
					value: id,
					label: `${id}: ${name}`,
					comm: commodity_id
				}))
			);
		}
	}, [sites, formValue.siteComm, formValue.siteProdState]);

	const handleSelectedSiteOptions = (selectedValues) => {
		setSelectedSiteOptions(selectedValues);
		setFormValue({
			...formValue,
			siteIds: selectedValues.map((site) => site.value)
		});
	};

	const handleSelectedUserOptions = (selectedValues) => {
		setSelectedUserOptions(selectedValues);
	};

	const handleCaptureIDChange = (e) => {
		/**
		 * as capture IDs are added, tidy list and add to form values
		 */

		console.log(e.target.value);

		let input = e.target.value;

		// Normalize the input, replacing commas and spaces as per your logic
		const normalizedInput = input
			.replace(/\s+(?=\d)/g, ',')
			.replace(/,\s*/g, ' ');

		// Split the input by spaces or commas, map to numbers, and filter out NaN values
		const result = normalizedInput
			.split(/[\s,]+/)
			.filter((item) => item !== '') // Avoid empty strings
			.map((item) => Number(item)) // Convert to number
			.filter((num) => !isNaN(num)); // Filter out NaN values

		// Update the form value
		setFormValue({ ...formValue, captureIds: result });
	};

	let captureProps = [
		{
			title: 'Home',
			currentPage: false,
			link: '/',
			afterCurrent: false,
			warning: false
		},
		{
			title: 'Captures',
			currentPage: false,
			link: '/capture',
			afterCurrent: false,
			warning: false
		},
		{
			title: 'Capture 5060',
			currentPage: true,
			link: '/capture/5060',
			afterCurrent: false,
			warning: false
		}
	];

	useEffect(() => {
		document.title = `GAINS | Capture (${exportConfig.gainsEnvironment})`;

		setFormValue(formInitialValues);

		setUserOptions(
			qcUsers.map((user, idx) => ({
				value: idx,
				label: `${user.givenName.toLowerCase()}.${user.familyName.toLowerCase()}`
			}))
		);

	}, []);

	const handleSelectAll = (event, stateKey) => {
		const { value, checked } = event.target;
	};

	const handleStateChange = (event, stateKey, inputCat) => {
		/**
		 * handle change for checkboxes to add/remove values
		 * to formValue as they are clicked
		 *
		 * used for commodity, production state, sensor, qc stage
		 */

		const { value, checked } = event.target;
		const parsedValue = isNaN(parseInt(value)) ? value : parseInt(value);

		if (parsedValue === 'all') {
			// If the "All" option is selected/deselected
			setFormValue((prevState) => ({
				...prevState,
				[stateKey]: checked ? inputCat : [] // Select all or clear all
			}));
		} else {
			// For individual checkbox changes
			setFormValue((prevState) => {
				const stateArray = prevState[stateKey];

				if (checked) {
					return {
						...prevState,
						[stateKey]: [...stateArray, parsedValue]
					};
				} else {
					return {
						...prevState,
						[stateKey]: stateArray.filter((item) => item !== parsedValue)
					};
				}
			});
		}
	};

	const fetchingCaptures = async (e) => {
		/**
		 * upon form submit, fetch captures relevant to form data
		 */

		fetchCaptures.resetData();
		setFormUpdated(false);

		await fetchCaptures.makeRequest(
			fetchCapturesUrl,
			'GET',
			null,
			'captures..'
		);
	};

	useEffect(() => {
		//fetchCaptures.resetData();

		if (fetchCaptures.error) {
			console.log(fetchCaptures.error);

			if (
				fetchCaptures.error?.errorMsj ===
				"'UnsupportedResultException' object is not iterable"
			) {
				fetchCaptures.setError(
					'Too many captures to return.  Try narrowing down the date range, or adding additional filter criteria.'
				);
			}
		} else {
		}
	}, [fetchCaptures.data, fetchCaptures.error]);

	const renderSkeletonTable = (style) => {
		return (
			<div className="table-responsive my-4" style={{ maxHeight: '400px' }}>
				<table className="table">
					<thead className="table-light">
						<tr>
							<th scope="col">ID</th>
							<th scope="col">Capture Date</th>
							<th scope="col">Site</th>
							<th scope="col">Sensor</th>
							<th scope="col">Site ID</th>

							<th scope="col">Initial State</th>
							<th scope="col">State</th>
							<th scope="col">QC State</th>
							<th scope="col">QC Date</th>
							<th scope="col">QC User</th>
							<th scope="col">
								View image
								{/* <i className="fa-regular fa-image"></i> */}
							</th>
						</tr>
					</thead>
					<tbody className="table-group-divider">
						{Array.from({ length: 5 }, (_, rowIndex) => (
							<tr key={rowIndex} style={{ height: '30px' }}>
								{Array.from({ length: 11 }, (_, rowIndex) => (
									<td className="table-light">
										{style === 'skeleton' ? <Skeleton /> : null}
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	};

	const handleKeyDown = (event, formType) => {
		if (event.key === 'Enter') {
			let value = '';
			if (formType === 'queueIds') {
				value = inputValueQueueIds.trim();
			} else {
				value = inputValueCaptureIds.trim();
			}

			// Check for 6 or 7 digit numbers
			if (/^\d{5,7}$/.test(value)) {
				const newOption = { label: value, value };

				if (formType === 'queueIds') {
					if (!formValue.queueIds.some((opt) => opt.value === value)) {
						setFormValue((prev) => ({
							...prev,
							queueIds: [...prev.queueIds, newOption]
						}));
						setInputValueQueueIds('');
					}
				} else {
					if (!formValue.captureIds.some((opt) => opt.value === value)) {
						setFormValue((prev) => ({
							...prev,
							captureIds: [...prev.captureIds, newOption]
						}));

						setInputValueCaptureIds('');
					}
				}
			} else {
				// Optional: Add validation feedback
				console.warn('Please enter a 6- or 7-digit number');
			}

			event.preventDefault(); // Prevent default enter behavior
		}
	};

	const handleInputChangeCaptureIDs = (value, { action }) => {
		if (action === 'input-change') {
			const numericValue = value.replace(/\D/g, '');
			setInputValueCaptureIds(numericValue);
		}
	};

	const handleInputChangeQueueIDs = (value, { action }) => {
		if (action === 'input-change') {
			const numericValue = value.replace(/\D/g, '');
			setInputValueQueueIds(numericValue);
		}
	};

	const handleChangeCaptureID = (options) => {
		console.log("options",options)
		setFormValue((prev) => ({
			...prev,
			captureIds: options || []
		}));
	};

	const handleChangeQueueID = (options) => {
		setFormValue((prev) => ({
			...prev,
			queueIds: options || []
		}));
	};

	console.log(formValue);

	return (
		<>
			{props.authProps.isAuthenticated ? (
				<Col className="px-0">
					<div className="contentContainer" style={{ overflow: 'auto' }}>
						<CaptureModal
							currentImage={currentImage}
							setCurrentImage={setCurrentImage}
							siteType={formValue.siteType}
						/>

						<hr style={{ marginTop: '58px' }}></hr>
						<h2>Captures</h2>
						<h5>Use this page to fetch captures within given criteria</h5>

						<div class="accordion mt-4" id="accordionExample">
							<div class="accordion-item">
								<h2 class="accordion-header" id="headingOne">
									<button
										className={`accordion-button ${
											!criteriaFormIsOpen ? 'collapsed' : ''
										}`}
										type="button"
										onClick={toggleAccordion}
										aria-expanded={criteriaFormIsOpen}
										aria-controls="collapseOne"
									>
										Capture Criteria Form
									</button>
								</h2>
								<div
									id="collapseOne"
									className={`accordion-collapse collapse ${
										criteriaFormIsOpen ? 'show' : ''
									}`}
									aria-labelledby="headingOne"
									data-bs-parent="#accordionExample"
								>
									<div
										class="accordion-body"
										style={{
											// overflowY: 'scroll',
											backgroundColor: '#f8f9fa',
											maxHeight: '72vh',
											padding: '5px'
										}}
									>
										<div className="row">
											{/* SITES INFO */}
											<div className="col">
												<fieldset
													className="form-group p-3 border rounded-3"
													style={{ height: '100%', backgroundColor: 'white' }}
												>
													<legend className="float-none w-auto px-3 my-0 fs-6 fw-bold">
														Site Info
													</legend>

													{/* <div className="row mb-4">
														<label
															for="captures-site-type"
															className={
																formValue.siteType
																	? 'text-dark'
																	: 'text-secondary'
															}
														>
															*Site Type
														</label>
														<p className="py-0 my-0 fst-italic">
															select one option
														</p>

														<div className="d-flex flex-row mt-1">
															<div className="form-check-dashboard-qcinfo">
																<input
																	className="form-check-input-dashboard-qcinfo"
																	type="radio"
																	name="captures-site-type-radios"
																	id="captures-site-type-radios-smelters"
																	defaultChecked={true}
																	onClick={(e) =>
																		setFormValue({ ...formValue, siteType: 1 })
																	}
																	disabled={loadingSites}
																></input>
																<label
																	className="form-check-label-dashboard-qcinfo"
																	htmlFor="captures-site-type-radios-smelters"
																	data-tooltip-id="captures-sitetype-radio-smelters"
																>
																	<i className="fa-solid fa-city"></i>
																</label>
															</div>
															<div className="form-check-dashboard-qcinfo">
																<input
																	className="form-check-input-dashboard-qcinfo"
																	type="radio"
																	name="captures-site-type-radios"
																	id="captures-site-type-radios-stockpiles"
																	onClick={(e) =>
																		setFormValue({ ...formValue, siteType: 3 })
																	}
																	disabled
																></input>
																<label
																	className="form-check-label-dashboard-qcinfo"
																	htmlFor="captures-site-type-radios-stockpiles"
																	data-tooltip-id="captures-sitetype-radio-stockpiles"
																>
																	<i className="fa-solid fa-cubes-stacked"></i>
																</label>
															</div>
															<div
																className="form-check-dashboard-qcinfo"
																data-tooltip-id="dashboard-qcinfo-airfields"
															>
																<input
																	className="form-check-input-dashboard-qcinfo"
																	type="radio"
																	name="captures-site-type-radios"
																	id="captures-site-type-radios-airfield"
																	onClick={(e) =>
																		setFormValue({ ...formValue, siteType: 2 })
																	}
																	disabled
																></input>
																<label
																	className="form-check-label-dashboard-qcinfo"
																	htmlFor="captures-site-type-radios-airfield"
																	data-tooltip-id="captures-sitetype-radio-airfield"
																>
																	<i className="fa-solid fa-tower-broadcast"></i>
																</label>
															</div>
														</div>

														<Tooltip id="captures-sitetype-radio-smelters">
															Smelters
														</Tooltip>
														<Tooltip id="captures-sitetype-radio-stockpiles">
															Stockpiles
														</Tooltip>
														<Tooltip id="captures-sitetype-radio-airfield">
															Airfield
														</Tooltip>
													</div> */}

													<div className="row my-2">
														<label className="label" for="captures-site-id">
															*Commodity
														</label>
														<p className="py-0 mt-0 mb-2 fst-italic">
															select one option
														</p>

														<div className="d-flex flex-row">
															{commsForSiteType.map((comm, idx) => (
																<>
																	<input
																		className="form-check-input-dashboard-qcinfo form-check-input"
																		type="radio"
																		name="captures-site-commodity"
																		id={`comm-${comm.id}`}
																		value={comm.id}
																		checked={formValue.siteComm === comm.id}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				siteComm: parseInt(comm.id)
																			})
																		}
																	></input>
																	<label
																		className="form-check-label-dashboard-qcinfo mx-1"
																		htmlFor={`comm-${comm.id}`}
																		data-tooltip-id="dashboard-qcinfo-smelters"
																	>
																		{comm.commodity}
																	</label>
																</>
															))}
														</div>
													</div>

													{formValue.siteType === 1 && (
														<div className="row my-4">
															<label
																className={
																	formValue.siteProdState.length > 0
																		? 'label'
																		: 'label fw-light'
																}
																for="captures-site-id"
															>
																Production State
															</label>
															<p className="py-0 mt-0 mb-2 fst-italic">
																select at least one option
															</p>

															<div className="ms-3">
																<div className="d-flex form-check">
																	<input
																		className={`form-check-input me-2 ${
																			formValue.siteProdState.length === 6
																				? 'form-check-input-alt'
																				: ''
																		}`}
																		type="checkbox"
																		name="captures-site-production-state"
																		id={`captures-site-prod-state-all`}
																		checked={
																			formValue.siteProdState.length ===
																			exportConfig.production_states.length
																		}
																		value="all"
																		onChange={(e) =>
																			handleStateChange(
																				e,
																				'siteProdState',
																				exportConfig.production_states.map(
																					(state) => state.state
																				)
																			)
																		}
																	></input>
																	<label
																		className={`form-check-label me-5 ${
																			formValue.siteProdState.length === 6
																				? 'form-check-label-alt me-5'
																				: ''
																		}`}
																		htmlFor={`captures-site-prod-state-all`}
																		data-tooltip-id={`captures-site-prod-state-all`}
																	>
																		All
																	</label>
																</div>
																{exportConfig.production_states.map(
																	(state, idx) => (
																		<div
																			key={idx}
																			className="d-flex form-check"
																		>
																			<input
																				className={`form-check-input me-2 ${
																					formValue.siteProdState.length === 6
																						? 'form-check-input-alt'
																						: ''
																				}`}
																				type="checkbox"
																				name="captures-site-production-state"
																				id={`captures-site-prod-state-${state.state}`}
																				value={state.state}
																				checked={formValue.siteProdState.includes(
																					state.state
																				)}
																				data-tooltip-id={`captures-site-prod-state-${state.state}`}
																				onChange={(e) =>
																					handleStateChange(e, 'siteProdState')
																				}
																			></input>

																			<label
																				className={`form-check-label me-5 ${
																					formValue.siteProdState.length === 6
																						? 'form-check-label-alt me-5'
																						: ''
																				}`}
																				htmlFor={`captures-site-prod-state-${state.state}`}
																				data-tooltip-id={`captures-site-prod-state-${state.state}`}
																			>
																				{state.state}
																			</label>

																			<Tooltip
																				id={`captures-site-prod-state-${state.state}`}
																			>
																				Production state {state.state}
																				<br></br> {state.descript}
																			</Tooltip>
																		</div>
																	)
																)}
															</div>
														</div>
													)}

													<div className="row my-4">
														<label
															className={
																selectedSiteOptions.length > 0
																	? 'fw-bold label'
																	: 'label '
															}
															for="captures-site-id"
														>
															Site Name
														</label>

														{formValue.siteIds.length === 0 ? (
															<p className="py-0 mt-0 mb-2 fst-italic">
																fetch captures for all sites
															</p>
														) : (
															<p className="py-0 mt-0 mb-2 fst-italic">
																fetch captures for sites:{' '}
																{formValue.siteIds.map((site, idx) => (
																	<span key={idx}>{site}, </span>
																))}
															</p>
														)}

														{loadingSites && siteOptions !== null ? (
															<Skeleton height={30} />
														) : siteOptions !== null &&
														  siteOptions.length === 0 ? (
															<Select
																isMulti
																isDisabled
																placeholder="No sites for given criteria"
																style={{ zIndex: '9999' }}
															/>
														) : (
															<Select
																isMulti
																options={siteOptions}
																value={selectedSiteOptions}
																onChange={handleSelectedSiteOptions}
																isSearchable
																placeholder={`Search sites (${siteOptions.length})...`}
																style={{ zIndex: '9999' }}
															/>
														)}
													</div>
												</fieldset>
											</div>

											{/* CAPTURE INFO */}
											<div className="col">
												<fieldset
													className="form-group p-3 border rounded-3"
													style={{ height: '100%', backgroundColor: 'white' }}
												>
													<legend className="float-none w-auto px-3 my-0 fs-6 fw-bold">
														Capture Info
													</legend>

													{/* <div className="row my-3">
											<label
												for="captureIds"
												className={
													formValue.queueIds.length > 0
														? 'fw-bold form-label'
														: 'form-label '
												}
											>
												Queue ID (s)
											</label>
											<div className="row">
												<Select
													isMulti
													options={[]}
													value={formValue.queueIds}
													onChange={handleChangeQueueID}
													inputValue={inputValueQueueIds}
													onInputChange={handleInputChangeQueueIDs}
													onKeyDown={(e) => handleKeyDown(e, 'queueIds')}
													placeholder="Type a 5, 6 or 7-digit number then press enter"
													isClearable
													noOptionsMessage={() => null}
												/>
											</div>
										</div> */}

													<div className="row my-3">
														<label
															for="captureIds"
															className={
																formValue.captureIds.length > 0
																	? 'fw-bold form-label'
																	: 'form-label '
															}
														>
															Capture ID (s)
														</label>
														<div className="row">
															<Select
																isMulti
																options={[]}
																value={formValue.captureIds}
																onChange={handleChangeCaptureID}
																inputValue={inputValueCaptureIds}
																onInputChange={handleInputChangeCaptureIDs}
																onKeyDown={(e) =>
																	handleKeyDown(e, 'captureIds')
																}
																placeholder="Type a 5, 6 or 7-digit number then press enter"
																isClearable
																noOptionsMessage={() => null}
															/>
														</div>
													</div>

													<div className="row my-3">
														<label
															for="captures-capture-qc-state"
															className={
																formValue.captureStartDate ||
																formValue.captureEndDate
																	? 'fw-bold form-label'
																	: 'form-label '
															}
														>
															Capture Date
														</label>

														{formValue.allowCaptureDates ? (
															<p className="py-0 mt-0 mb-2 fst-italic">
																fetch captures for {formValue.captureStartDate}{' '}
																to {formValue.captureEndDate} (
																{calcDatesDiff(
																	formValue.captureStartDate,
																	formValue.captureEndDate
																)}
																)
															</p>
														) : (
															<p className="py-0 mt-0 mb-2 fst-italic">
																fetch captures for all dates (2016-01-01 to{' '}
																{new Date().toISOString().split('T')[0]})
															</p>
														)}

														<div className="row">
															<div className="col d-flex justify-content-center align-items-center">
																<input
																	type="checkbox"
																	value={formValue.allowCaptureDates}
																	onChange={(e) =>
																		setFormValue({
																			...formValue,
																			allowCaptureDates:
																				!formValue.allowCaptureDates
																		})
																	}
																	className="form-check-input me-3"
																></input>
																<p className="my-0 py-0">between</p>
																<input
																	type="date"
																	value={formValue.captureStartDate}
																	onChange={(e) =>
																		setFormValue({
																			...formValue,
																			captureStartDate: e.target.value
																		})
																	}
																	max={new Date().toISOString().split('T')[0]}
																	className="form-control ms-1 me-2"
																	disabled={!formValue.allowCaptureDates}
																></input>
															</div>
															<div className="col d-flex justify-content-center align-items-center">
																<p className="my-0 py-0">and</p>
																<input
																	type="date"
																	value={formValue.captureEndDate}
																	onChange={(e) =>
																		setFormValue({
																			...formValue,
																			captureEndDate: e.target.value
																		})
																	}
																	max={new Date().toISOString().split('T')[0]}
																	className="form-control  ms-1 me-2"
																	disabled={!formValue.allowCaptureDates}
																></input>
															</div>
														</div>
													</div>

													{formValue.siteType === 1 && (
														<div className="row my-3">
															<label
																for="captures-capture-sensors"
																className={
																	formValue.sensors.length > 0
																		? 'fw-bold form-label'
																		: 'form-label '
																}
															>
																Sensors
															</label>
															<div className="d-flex flex-column align-items-start">
																{exportConfig.sensors.map((sensor, idx) => (
																	<div className="form-check d-flex justify-content-end">
																		<input
																			className={`form-check-input me-4 ${
																				formValue.sensors.length === 3
																					? 'form-check-input-alt me-4'
																					: ''
																			}`}
																			type="checkbox"
																			id={sensor}
																			name="formSensors"
																			value={sensor}
																			onChange={(e) =>
																				handleStateChange(e, 'sensors')
																			}
																			checked={formValue.sensors.includes(
																				sensor
																			)}
																		></input>
																		<label
																			for={sensor}
																			className={`form-check-label me-5 ${
																				formValue.sensors.length === 3
																					? 'fform-check-label me-5-alt me-5'
																					: ''
																			}`}
																		>
																			{sensor}
																		</label>
																	</div>
																))}
															</div>
														</div>
													)}

													{formValue.siteType === 3 && (
														<div className="row my-3">
															<div className="col-3">
																<label
																	for="captures-capture-models"
																	className={
																		formValue.models.length > 0
																			? 'fw-bold form-label'
																			: 'form-label '
																	}
																>
																	Model
																</label>
															</div>
															<div className="col-9 d-flex flex-column align-items-end">
																{exportConfig.models.map((model, idx) => (
																	<div className="form-check d-flex justify-content-end">
																		<label
																			for={model}
																			className="form-check-label me-5"
																		>
																			{model}
																		</label>
																		<input
																			className="form-check-input me-4"
																			type="checkbox"
																			id={model}
																			name="formSensors"
																			value={model}
																			onChange={(e) =>
																				handleStateChange(e, 'models')
																			}
																			checked={formValue.models.includes(model)}
																		></input>
																	</div>
																))}
															</div>
														</div>
													)}

													{formValue.siteType === 3 && (
														<div className="row my-3">
															<div className="col-4 d-flex align-items-center">
																<input
																	type="checkbox"
																	className="form-check-input me-2"
																	defaultValue={false}
																	value={formValue.allowPixels}
																	onChange={(e) =>
																		setFormValue({
																			...formValue,
																			allowPixels: !formValue.allowPixels
																		})
																	}
																></input>
																<label
																	for="captures-capture-pixels"
																	className={
																		formValue.allowPixels
																			? 'fw-bold form-label py-0 my-0'
																			: 'form-label py-0 my-0'
																	}
																>
																	Pixel Count
																</label>
															</div>
															<div className="col-8 d-flex justify-control-center align-items-center">
																<p className="my-0 py-0">from</p>
																<input
																	className="form-control mx-3"
																	type="number"
																	value={formValue.pixelsMin}
																	onChange={(e) =>
																		setFormValue({
																			...formValue,
																			pixelsMin: e.target.value
																		})
																	}
																	disabled={!formValue.allowPixels}
																></input>
																<p className="my-0 py-0">to</p>
																<input
																	className="form-control mx-3"
																	type="number"
																	value={formValue.pixelsMax}
																	onChange={(e) =>
																		setFormValue({
																			...formValue,
																			pixelsMax: e.target.value
																		})
																	}
																	disabled={!formValue.allowPixels}
																></input>
															</div>
														</div>
													)}

													{formValue.siteType === 1 && (
														<>
															<div className="row my-3">
																<div className="col-4 d-flex align-items-center">
																	<input
																		type="checkbox"
																		className="form-check-input me-2"
																		defaultValue={false}
																		value={formValue.allowHotspots}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				allowHotspots: !formValue.allowHotspots
																			})
																		}
																	></input>
																	<label
																		for="captures-capture-sensors"
																		className={
																			formValue.allowHotspots
																				? 'fw-bold form-label py-0 my-0'
																				: 'form-label py-0 my-0'
																		}
																	>
																		Hotspots
																	</label>
																</div>
																<div className="col-8 d-flex justify-control-center align-items-center">
																	<p className="my-0 py-0">from</p>
																	<input
																		className="form-control mx-3"
																		type="number"
																		value={formValue.hotspotsMin}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				hotspotsMin: e.target.value
																			})
																		}
																		disabled={!formValue.allowHotspots}
																	></input>
																	<p className="my-0 py-0">to</p>
																	<input
																		className="form-control mx-3"
																		type="number"
																		value={formValue.hotspotsMax}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				hotspotsMax: e.target.value
																			})
																		}
																		disabled={!formValue.allowHotspots}
																	></input>
																</div>
															</div>

															<div className="row my-3">
																<div className="col-4 d-flex align-items-center">
																	<input
																		type="checkbox"
																		className="form-check-input me-2"
																		defaultValue={false}
																		value={formValue.allowCloudFrac}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				allowCloudFrac:
																					!formValue.allowCloudFrac
																			})
																		}
																	></input>
																	<label
																		for="captures-capture-sensors"
																		className={
																			formValue.allowCloudFrac
																				? 'fw-bold form-label py-0 my-0'
																				: 'form-label py-0 my-0'
																		}
																	>
																		Cloud Fraction
																	</label>
																</div>
																<div className="col-8 d-flex justify-control-center align-items-center">
																	<p className="my-0 py-0">from</p>
																	<input
																		className="form-control mx-3"
																		type="number"
																		min={0}
																		max={1}
																		value={formValue.cloudFracMin}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				cloudFracMin: e.target.value
																			})
																		}
																		disabled={!formValue.allowCloudFrac}
																	></input>
																	<p className="my-0 py-0">to</p>
																	<input
																		className="form-control mx-3"
																		type="number"
																		max={1}
																		value={formValue.cloudFracMax}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				cloudFracMax: e.target.value
																			})
																		}
																		disabled={!formValue.allowCloudFrac}
																	></input>
																</div>
															</div>

															<div className="row my-3">
																<div className="col-4 d-flex align-items-center">
																	<input
																		type="checkbox"
																		className="form-check-input me-2"
																		defaultValue={false}
																		value={formValue.allowInvalidDataFrac}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				allowInvalidDataFrac:
																					!formValue.allowInvalidDataFrac
																			})
																		}
																	></input>
																	<label
																		for="captures-capture-sensors"
																		className={
																			formValue.allowInvalidDataFrac
																				? 'fw-bold form-label py-0 my-0'
																				: 'form-label py-0 my-0'
																		}
																	>
																		Invalid Data Fraction
																	</label>
																</div>
																<div className="col-8 d-flex justify-control-center align-items-center">
																	<p className="my-0 py-0">from</p>
																	<input
																		className="form-control mx-3"
																		type="number"
																		min={0}
																		max={1}
																		value={formValue.invalidDataFracMin}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				invalidDataFracMin: e.target.value
																			})
																		}
																		disabled={!formValue.allowInvalidDataFrac}
																	></input>
																	<p className="my-0 py-0">to</p>
																	<input
																		className="form-control mx-3"
																		type="number"
																		max={1}
																		value={formValue.invalidDataFracMax}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				invalidDataFracMax: e.target.value
																			})
																		}
																		disabled={!formValue.allowInvalidDataFrac}
																	></input>
																</div>
															</div>
														</>
													)}
												</fieldset>
											</div>

											{/* QC INFO */}
											<div className="col">
												<fieldset
													className="form-group p-3 border rounded-3"
													style={{
														height: '100%',
														position: 'relative',
														backgroundColor: 'white'
													}}
												>
													<legend className="float-none w-auto px-3 my-0 fs-6 fw-bold">
														QC Info
													</legend>

													<div
														className="row my-3"
														data-tooltip-id="captures-capture-qc-state"
													>
														<div className="col-3">
															<label
																for="captures-capture-qc-state"
																className={
																	formValue.qcStates.length > 0
																		? 'fw-bold form-label py-0 my-0'
																		: 'form-label py-0 my-0'
																}
															>
																QC Status
															</label>
														</div>
														<div className="col-9 d-flex flex-column">
															{exportConfig.qcStages.map((stage, idx) => (
																<div
																	key={idx}
																	className="d-flex justify-content-end"
																>
																	<label
																		className={`form-check-label ms-1 me-4 ${
																			formValue.qcStates.length === 2
																				? 'form-check-label-alt ms-1 me-4'
																				: ''
																		}`}
																		htmlFor={`captures-capture-qc-state-${stage.id}`}
																	>
																		{stage.descript}
																	</label>
																	<input
																		className={`form-check-input me-3 ${
																			formValue.qcStates.length === 2
																				? 'form-check-input-alt me-3'
																				: ''
																		}`}
																		type="checkbox"
																		name="captures-capture-qc-state"
																		id={`captures-capture-qc-state-${stage.id}`}
																		value={stage.id}
																		checked={formValue.qcStates.includes(
																			stage.id
																		)}
																		onChange={(e) =>
																			handleStateChange(e, 'qcStates')
																		}
																	></input>
																</div>
															))}
														</div>
													</div>

													{formValue.siteType === 1 && (
														<>
															<div className="row my-3">
																<div className="col-6">
																	<div className="row">
																		<div className="col-6">
																			<label
																				for="captures-capture-qc-state"
																				className={
																					!formValue.qcStates.includes(4) &&
																					!formValue.qcStates.includes(1)
																						? 'fst-italic'
																						: formValue.qcInitialState.length >
																							  0
																							? 'fw-bold'
																							: 'form-label'
																				}
																			>
																				QC Initial State
																			</label>
																		</div>
																		<div
																			className="col-6 d-flex flex-column"
																			data-tooltip-id="captures-capture-qc-initial-state"
																		>
																			{exportConfig.qcStates.map(
																				(state, idx) => (
																					<div
																						key={idx}
																						className="d-flex justify-content-end"
																					>
																						<label
																							for={`captures-qc-initial-state-${state.stateInt}`}
																							//className="form-label ms-1 me-3"
																							className={
																								formValue.siteProdState.length >
																								0
																									? 'label ms-1 me-3'
																									: 'label fw-light ms-1 me-3'
																							}
																						>
																							{state.stateString}
																						</label>
																						<input
																							className={`form-check-input me-2 ${
																								formValue.qcInitialState
																									.length === 4
																									? 'form-check-input-alt'
																									: ''
																							}`}
																							type="checkbox"
																							name="captures-qc-initial-state"
																							value={state.stateInt}
																							checked={formValue.qcInitialState.includes(
																								state.stateInt
																							)}
																							id={`captures-qc-final-state-${state.stateInt}`}
																							// disabled={
																							// 	!formValue.qcStates.includes(4) &&
																							// 	!formValue.qcStates.includes(1)
																							// }
																							onChange={(e) =>
																								handleStateChange(
																									e,
																									'qcInitialState'
																								)
																							}
																						></input>
																					</div>
																				)
																			)}
																		</div>
																	</div>
																</div>

																<div className="col-6">
																	<div className="row">
																		<div className="col-6">
																			<label
																				for="captures-capture-qc-final-state"
																				className={
																					!formValue.qcStates.includes(4) &&
																					!formValue.qcStates.includes(1)
																						? 'fst-italic'
																						: formValue.qcFinalState.length > 0
																							? 'fw-bold'
																							: 'form-label'
																				}
																			>
																				QC Final State
																			</label>
																		</div>
																		<div
																			className="col-6 d-flex flex-column"
																			data-tooltip-id="captures-capture-qc-final-state"
																		>
																			{exportConfig.qcStates.map(
																				(state, idx) => (
																					<div
																						key={idx}
																						className="d-flex justify-content-end"
																					>
																						<label
																							for={`captures-qc-final-state-${state.stateInt}`}
																							className={
																								formValue.qcFinalState.length >
																								0
																									? 'label ms-1 me-3'
																									: 'label fw-light ms-1 me-3'
																							}
																						>
																							{state.stateString}
																						</label>

																						<input
																							className={`form-check-input me-2 ${
																								formValue.qcFinalState
																									.length === 4
																									? 'form-check-input-alt'
																									: ''
																							}`}
																							type="checkbox"
																							checked={formValue.qcFinalState.includes(
																								state.stateInt
																							)}
																							name="captures-qc-final-state"
																							value={state.stateInt}
																							id={`captures-qc-final-state-${state.stateInt}`}
																							disabled={
																								!formValue.qcStates.includes(1)
																							}
																							onChange={(e) =>
																								handleStateChange(
																									e,
																									'qcFinalState'
																								)
																							}
																						></input>
																					</div>
																				)
																			)}
																		</div>
																	</div>
																</div>
															</div>

															<Tooltip
																id="captures-capture-qc-initial-state"
																place="bottom"
																effect="solid"
															>
																Filter by the{' '}
																<span className="fw-bold">initial state</span>{' '}
																the <br></br> capture was set to (ie Pre-QC
																state)
															</Tooltip>

															<Tooltip
																id="captures-capture-qc-final-state"
																place="bottom"
																effect="solid"
															>
																If the capture has been QC'd,<br></br> filter by
																the
																<span className="fw-bold">
																	{' '}
																	final state
																</span>{' '}
																the capture was set to (by a user or Auto-QC)
															</Tooltip>
														</>
													)}

													{formValue.qcStates.includes(1) ? (
														// ie QC'd captures

														<>
															<div className="row my-3">
																<div className="col-3 d-flex align-items-center">
																	<label
																		for="captures-capture-qc-date"
																		className={
																			!formValue.qcStates.includes(4) &&
																			!formValue.qcStates.includes(1)
																				? 'fst-italic'
																				: selectedUserOptions.length > 0
																					? 'fw-bold form-label py-0 my-0'
																					: 'form-label py-0 my-0'
																		}
																		s
																	>
																		QC Date
																	</label>
																</div>
																<div className="col-9 d-flex justify-control-center align-items-center">
																	<p className="my-0 py-0">between</p>
																	<input
																		style={{ width: '37%' }}
																		type="date"
																		className="form-control ms-1 me-2"
																		value={formValue.qcStartDate}
																		disabled={
																			!formValue.qcStates.includes(4) &&
																			!formValue.qcStates.includes(1)
																		}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				qcStartDate: e.target.value
																			})
																		}
																	></input>
																	<p className="my-0 py-0">and</p>
																	<input
																		style={{ width: '37%' }}
																		type="date"
																		className="form-control  ms-1 me-2"
																		disabled={
																			!formValue.qcStates.includes(4) &&
																			!formValue.qcStates.includes(1)
																		}
																		value={formValue.qcEndDate}
																		onChange={(e) =>
																			setFormValue({
																				...formValue,
																				qcEndDate: e.target.value
																			})
																		}
																	></input>
																</div>
															</div>

															<div
																className="row my-3"
																data-tooltip-id="captures-capture-qc-user"
															>
																<div className="col-3">
																	<label
																		for="captures-capture-qc-user"
																		className={
																			!formValue.qcStates.includes(4) &&
																			!formValue.qcStates.includes(1)
																				? 'fst-italic'
																				: selectedUserOptions.length > 0
																					? 'fw-bold form-label py-0 my-0'
																					: 'form-label py-0 my-0'
																		}
																	>
																		QC User
																	</label>
																</div>
																<div className="col-9 d-flex justify-control-center">
																	<Select
																		styles={{
																			container: (provided) => ({
																				...provided,
																				width: '95%'
																			})
																		}}
																		isMulti
																		options={userOptions}
																		value={selectedUserOptions}
																		onChange={handleSelectedUserOptions}
																		isSearchable
																		menuPlacement="top"
																		placeholder="Search and select users..."
																		isDisabled={
																			!formValue.qcStates.includes(4) &&
																			!formValue.qcStates.includes(1)
																		}
																	/>
																</div>
															</div>

															<Tooltip id="captures-capture-qc-state">
																Filter captures by QC stage:<br></br>0: Not QC'd
																<br></br>
																3: Currently in QC<br></br>
																4: QC'd but not uploaded<br></br>1: QC'd and
																uploaded
															</Tooltip>

															{/* <div
													className="row my-3"
													data-tooltip-id="captures-capture-qc-states-not-equal"
												>
													<label
														for="captures-capture-qc-state"
														data-tooltip-id="qc-states-agree"
														className={
															formValue.qcStates.length > 0
																? 'fw-bold form-label py-0 my-0'
																: 'form-label py-0 my-0'
														}
													>
														QC states agree
													</label>

													<Tooltip id="qc-states-agree">
														Filter by captures where the initial state
														(determined by Pre-QC) and final state either{' '}
														<strong>agree</strong> or <strong>disagree</strong>
													</Tooltip>

													<div className="col-4">
														<div className="d-flex justify-content-end">
															<label
																className="form-check-label ms-1 me-4"
																htmlFor="qc-states-agree"
															>
																Agree
															</label>
															<input
																className="form-check-input me-3"
																type="checkbox"
																name="captures-capture-qc-state-agree"
																id="qc-states-agree"
																value="true"
																checked={formValue.qcStatesAgree}
																onChange={() =>
																	setFormValue((prev) => ({
																		...prev,
																		qcStatesAgree: !prev.qcStatesAgree
																	}))
																}
															></input>
														</div>
													</div>
													<div className="col-4">
														<div className="d-flex justify-content-end">
															<label
																className="form-check-label ms-1 me-4"
																htmlFor="qc-states-agree"
															>
																Disagree
															</label>
															<input
																className="form-check-input me-3"
																type="checkbox"
																name="captures-capture-qc-state-agree"
																id="qc-states-agree"
																value="false"
																checked={formValue.qcStatesDisagree}
																onChange={() =>
																	setFormValue((prev) => ({
																		...prev,
																		qcStatesDisagree: !prev.qcStatesDisagree // or any logic you need
																	}))
																}
															></input>
														</div>
													</div>

													{formValue.qcStatesAgree &&
													!formValue.qcStatesDisagree ? (
														<p>
															only select captures where the initial state and
															final state agree
														</p>
													) : !formValue.qcStatesAgree &&
													  formValue.qcStatesDisagree ? (
														<p>
															only select captures where the initial state and
															final state disagree
														</p>
													) : (
														<></>
													)}
												</div> */}
														</>
													) : null}

													<div
														className="row"
														style={{
															position: 'absolute',
															bottom: '20px',
															width: '100%'
														}}
													>
														<div className="col-8">
															{!formValid && (
																<h5 className="text-warning">
																	{' '}
																	<i className="fa-solid fa-triangle-exclamation me-3"></i>
																	{formValidReason}
																</h5>
															)}
															{typeof fetchCaptures.error === 'string' && (
																<>
																	<h5 className="text-warning">
																		<i className="fa-solid fa-triangle-exclamation me-3"></i>{' '}
																		{fetchCaptures.error}
																	</h5>
																</>
															)}
														</div>
														<div className="col-4 d-flex align-items-end justify-content-end">
															<button
																className="btn interactButton"
																onClick={() => fetchingCaptures()}
																disabled={!formValid || loadingSites}
															>
																Fetch captures
															</button>
														</div>
													</div>
												</fieldset>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						{/* CAPTURES TABLE */}
						<div className="row mt-4">
							{fetchCaptures?.data?.data ? (
								<h4 className="text-center">
									Captures ({fetchCaptures.data.data.length})
								</h4>
							) : (
								<h4 className="text-center">Captures </h4>
							)}

							{fetchCaptures.loading ? (
								<>{renderSkeletonTable('skeleton')}</>
							) : fetchCaptures?.data?.data &&
							  fetchCaptures.data.data.length > 0 ? (
								<>
									{/* <div className="table-responsive">
										{formValue.siteComm === 3 && (
											<CapturesTable
												fields={smelterFieldsCapturesPage}
												captures={fetchCaptures.data.data}
												qcCat="smelters"
												tableHeight="500px"
												capturesPage={true}
												setCurrentImage={setCurrentImage}
											/>
										)}
									</div> */}

									<div
										className="table-responsive"
										style={{ height: '600px', overflow: 'auto' }}
									>
										<table
											className="captureTable"
											style={{
												width: '100%',
												tableLayout: 'fixed',
												borderCollapse: 'collapse',
												margin: 0
											}}
										>
											<thead
												style={{
													position: 'sticky',
													top: 0,
													backgroundColor: '#fff'
												}}
											>
												<tr>
													<th scope="col">ID</th>
													<th scope="col">Capture Date</th>
													<th scope="col">Site ID</th>

													<th scope="col">Sensor</th>

													{formValue.siteComm === 3 && (
														<th scope="col">Initial State</th>
													)}

													<th scope="col">QC'd</th>

													<th scope="col">View image</th>
												</tr>
											</thead>

											<tbody>
												{fetchCaptures.data.data.map((capture, idx) => (
													<tr key={idx}>
														<td>{capture.id}</td>
														{capture.captured ? (
															<td>{capture.captured.split(' ')[0]}</td>
														) : (
															<td>-</td>
														)}

														{capture?.site_id && <td>{capture.site_id}</td>}

														<td>{capture.sensor}</td>

														{formValue.siteComm === 3 && (
															<td>
																{
																	exportConfig.qcStates.filter(
																		(qstate) =>
																			qstate.stateInt === capture.initial_state
																	)[0].stateString
																}
															</td>
														)}

														<td>
															{exportConfig.qcStages.filter(
																(qstate) => qstate.id === capture.qc_state
															)[0].qcd === false ? (
																<></>
															) : (
																<i className="fa-solid fa-circle-check"></i>
															)}
														</td>

														{capture['stac_item_id'] !== null ? (
															<td
																data-bs-toggle="modal"
																data-bs-target="#captureModal"
																onClick={(e) => setCurrentImage(capture)}
																title={`View capture ${capture.id}`}
															>
																<i className="fa-solid fa-arrow-up-right-from-square"></i>
															</td>
														) : (
															<td
																style={{ color: 'grey' }}
																title="This capture cannot be viewed (no stac item ID)"
															></td>
														)}
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</>
							) : (
								<>
									<h4 className="text-secondary text-center">0 captures</h4>
								</>
							)}
						</div>
					</div>
				</Col>
			) : (
				<Navigate to="/login" />
			)}
		</>
	);
}
